import Button from '@hellodarwin/core/lib/components/common/button';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import Informations from '@hellodarwin/icons/dist/icons/Informations';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import {
  GinStepsState,
  InvalidGinFormModalActions,
  InvalidGinFormModalActionsPrimary,
} from './styles';

interface InvalidGinFormProps {
  onClose: () => void;
}

const InvalidGinForm: React.FC<InvalidGinFormProps> = ({ onClose }) => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <GinStepsState>
      <Informations size={70} color={theme.colors.yellow_1} />
      <InvalidGinFormModalActions>
        <Typography elementTheme="h5" textAlign="center">
          {t('gin_steps|invalidGinFormTitle')}
        </Typography>
        <Typography elementTheme="body1" textAlign="center">
          {t('gin_steps|invalidGinFormBody')}
        </Typography>
      </InvalidGinFormModalActions>

      <InvalidGinFormModalActionsPrimary>
        <Button
          onClick={() => {
            onClose();
          }}
          defaultStyle={theme.colors.yellow_1}
        >
          {t('gin_steps|askForSteps')}
        </Button>
        <Button
          onClick={() => {
            navigate('/funding-explorer');
          }}
        >
          {t('gin_steps|goToFundingExplorer')}
        </Button>
      </InvalidGinFormModalActionsPrimary>
    </GinStepsState>
  );
};

export default InvalidGinForm;
